export const ui = {
  btnPrimary:
    "inline-flex items-center justify-center gap-2 bg-[#8B1A1A] hover:bg-[#671813] text-[#F5EAE0] font-medium px-6 py-3 rounded-xl transition-colors duration-200 shadow-sm active:scale-[0.99] disabled:opacity-50 disabled:cursor-not-allowed",
  btnSecondary:
    "inline-flex items-center justify-center gap-2 border-2 border-[#8B1A1A] text-[#8B1A1A] hover:bg-[#8B1A1A] hover:text-[#F5EAE0] font-medium px-6 py-3 rounded-xl transition-colors duration-200 active:scale-[0.99]",
  btnGhost:
    "inline-flex items-center justify-center gap-2 text-[#8B1A1A] hover:bg-[#F3E5D8] font-medium px-4 py-2 rounded-xl transition-colors duration-150",
  input:
    "bg-[#E8DCC8] text-[#210201] placeholder-[#5A4441]/60 border border-[#E8DCC8] focus:border-[#8B1A1A] focus:bg-[#FFFDF9] focus:outline-none focus:ring-1 focus:ring-[#8B1A1A] rounded-xl px-4 py-3 w-full transition-colors duration-200",
  label: "block font-sans text-sm font-medium text-[#210201] mb-1.5",
  card:
    "bg-[#FFFDF9] border border-[#E8DCC8] rounded-xl shadow-[0_4px_20px_rgba(33,2,1,0.04)]",
  pill:
    "inline-flex items-center gap-1.5 bg-[#F3E5D8] text-[#8B1A1A] font-semibold text-xs px-3 py-1 rounded-full border border-[#E8DCC8]",
  caption: "font-sans text-xs uppercase tracking-wider text-[#5A4441]",
};

export const SECTIONS = [
  { code: "eo", label: "Expression orale", sub: "Speaking" },
  { code: "ee", label: "Expression écrite", sub: "Writing" },
  { code: "co", label: "Compréhension orale", sub: "Listening" },
  { code: "ce", label: "Compréhension écrite", sub: "Reading" },
];

export const SECTION_TAG_LABELS = {
  eo_a: "Expression orale · A",
  eo_b: "Expression orale · B",
  ee_a: "Expression écrite · A",
  ee_b: "Expression écrite · B",
  co: "Compréhension orale",
  ce: "Compréhension écrite",
};

export function formatDate(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-CA", { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return iso;
  }
}
